document.addEventListener('DOMContentLoaded', function() {
  const tocHeader = document.getElementById('toc-header');
  const toggleBtn = document.getElementById('toggle-btn');
  const tocContent = document.getElementById('toc-content');

  tocHeader.addEventListener('click', function() {
    tocContent.classList.toggle('collapsed');
    if (tocContent.classList.contains('collapsed')) {
      toggleBtn.textContent = '+';
    } else {
      toggleBtn.textContent = '−';
    }
  });
});